import { Stack, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import SymbolAutocompleteWrapper from '../../components/SymbolAutocompleteWrapper';
import { useSimulateActions, useSimulateMeta, useSimulateState } from '../SimulateTradeContext';
import { simulateOverlayZ } from '../constants';
import { SIMULATE_COPY } from '../content';
import { simulateFieldSx } from '../styles';

const { form } = SIMULATE_COPY;

/** Optional slave symbol; empty means the backend auto-maps the master symbol. */
export const CustomSlaveSymbolField = () => {
  const theme = useTheme();
  const { customSlaveSymbol } = useSimulateState();
  const { setCustomSlaveSymbol } = useSimulateActions();
  const { slaveAccountId } = useSimulateMeta();

  return (
    <Stack spacing={0.5}>
      <SymbolAutocompleteWrapper
        id="simulate-slave-symbol"
        label={form.slaveSymbol}
        selectedAccountId={slaveAccountId}
        defaultValue={customSlaveSymbol}
        disabled={!slaveAccountId}
        sx={simulateFieldSx(theme)}
        popperSx={{ zIndex: simulateOverlayZ }}
        onOptionSelect={(v) => setCustomSlaveSymbol(v?.name ?? '')}
      />
      <Typography variant="caption" color="text.secondary">
        {form.slaveSymbolHint}
      </Typography>
    </Stack>
  );
};
